export default __webpack_public_path__ + "static/media/passLogo.1e6fd885.svg";